import React from 'react';
import AppUpdateNotice from './AppUpdateNotice';
import {
  canAutoReload,
  isStaleBundleError,
  reloadForUpdate,
} from '../services/appUpdateRecovery';
import { recordRuntimeFailure } from '../services/runtimeFailureReport';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, reloading: false, reference: '', detail: '' };
  }

  static getDerivedStateFromError(error) {
    const reloading = isStaleBundleError(error) && canAutoReload();
    return { hasError: true, error, reloading, reference: '', detail: '' };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
    if (isStaleBundleError(error)) {
      reloadForUpdate();
      return;
    }
    const record = recordRuntimeFailure(error, errorInfo);
    this.setState({ reference: record.reference, detail: record.message });
  }

  render() {
    if (this.state.reloading) return <AppUpdateNotice reloading />;
    if (this.state.hasError && isStaleBundleError(this.state.error)) return <AppUpdateNotice updated />;
    if (this.state.hasError) {
      return (
        <AppUpdateNotice
          updated={false}
          reference={this.state.reference}
          detail={this.state.detail}
        />
      );
    }
    return this.props.children;
  }
}
